module.exports = __webpack_public_path__ + "static/media/mouthPressRight.786ab27d.obj";